import React from "react";
import {
  FaMapMarkedAlt,
  FaRegChartBar,
  FaRegComments,
  FaRegHeart,
  FaCheck,
  FaCalendarWeek,
} from "react-icons/fa";
import "./DashboardHome.css";
import dashprofile from "../../../../../images/avatar/3.jpg";
import DashMenu from "../../../../atoms/DashMenu/DashMenu";
import SubHeader from "../../../../atoms/SubHeader/SubHeader";

const DashboardHome = ({ toggleMenu, showMenu }) => {
  return (
    <div className="dashboard-home-wrapper">
      <div className="dashmenu-style">
        <DashMenu toggleMenu={toggleMenu} showMenu={showMenu} />
      </div>
      <SubHeader title={"DASHBOARD"}/>
      <div className="dash-home-content-wrapper">
        <div className="dash-home-content-left">
          <h3>Active Listings</h3>
          <div>
            <h4>124</h4>
          </div>
        </div>
        <div className="dash-home-content-map">
          <FaMapMarkedAlt className="dash-map" />
        </div>
      </div>
      <div className="dash-home-content-wrapper">
        <div className="dash-home-content-left">
          <h3>Listings Views</h3>
          <h4>1056</h4>
        </div>
        <div className="dash-home-content-map">
          <FaRegChartBar className="dash-map" />
        </div>
      </div>
      <div className="dash-home-content-wrapper">
        <div className="dash-home-content-left">
          <h3>Your Reviews</h3>
          <h4>357</h4>
        </div>
        <div className="dash-home-content-map">
          <FaRegComments className="dash-map" />
        </div>
      </div>
      <div className="dash-home-content-wrapper">
        <div className="dash-home-content-left">
          <h3>Times Bookmarked</h3>
          <h4>2329</h4>
        </div>
        <div className="dash-home-content-map">
          <FaRegHeart className="dash-map" />
        </div>
      </div>
      <div className="dash-home-bottom">
        <div className="home-box home-box1">
          <p>Your listing Family house in Brooklyn has been approved!</p>
        </div>
        <div className="home-box home-box2">
          <h4>
            Participate in our loyalty program. Refer a friend and get a
            discount.
          </h4>
          <a href="#jj">Read More</a>
        </div>
        <div className="home-box home-box3">
          <div className="home-box3header">
            <FaRegComments className="box1-icon" />
            <h4>Last Messages</h4>
          </div>
          <div className="home-box-message">
            <div>
              <img src={dashprofile} alt="hhhhh" />
            </div>
            <div className="home-box-test">
              <div className="home-box-inner">
                <h5>Mark Rose</h5>
                <p>27 Dec 2018</p>
              </div>
              <h2>
                Lorem ipsum dolor sit amet, voluptates mollitia obcaecati
                officiis vero vel aliquid reiciendis repellat laboriosam autem?
              </h2>
            </div>
          </div>
          <div className="home-box-message">
            <div>
              <img src={dashprofile} alt="hhhhh" />
            </div>
            <div className="home-box-test">
              <div className="home-box-inner">
                <h5>Mark Rose</h5>
                <p>27 Dec 2018</p>
              </div>
              <h2>
                Lorem ipsum dolor sit amet, voluptates mollitia obcaecati
                officiis vero vel aliquid reiciendis repellat laboriosam autem?
              </h2>
            </div>
          </div>
          <div className="home-box-message">
            <div>
              <img src={dashprofile} alt="hhhhh" />
            </div>
            <div className="home-box-test">
              <div className="home-box-inner">
                <h5>Mark Rose</h5>
                <p>27 Dec 2018</p>
              </div>
              <h2>
                Lorem ipsum dolor sit amet, voluptates mollitia obcaecati
                officiis vero vel aliquid reiciendis repellat laboriosam autem?
              </h2>
            </div>
          </div>
          <div className="home-box-message">
            <div>
              <img src={dashprofile} alt="hhhhh" />
            </div>
            <div className="home-box-test">
              <div className="home-box-inner">
                <h5>Mark Rose</h5>
                <p>27 Dec 2018</p>
              </div>
              <h2>
                Lorem ipsum dolor sit amet, voluptates mollitia obcaecati
                officiis vero vel aliquid reiciendis repellat laboriosam autem?
              </h2>
            </div>
          </div>
        </div>
        <div className="home-box home-box4">
          <div className="dash-home-content-check">
            <FaCheck className="dash-check" />
          </div>
          <p>
            Your listing <span className="check-p">Urban Appartments</span> has
            been approved!
          </p>
          <div className="calendar">
            <FaCalendarWeek className="calend" />
            <h5>28 may 2020</h5>
          </div>
        </div>
        <div className="home-box home-box4">
          <div className="dash-home-content-check">
            <FaRegComments className="dash-check" />
          </div>
          <p>
            Your listing <span className="check-p">Urban Appartments</span> has
            been approved!
          </p>
          <div className="calendar">
            <FaCalendarWeek className="calend" />
            <h5>28 may 2020</h5>
          </div>
        </div>
        <div className="home-box home-box4">
          <div className="dash-home-content-check">
            <FaRegHeart className="dash-check" />
          </div>
          <p>
            Your listing <span className="check-p">Urban Appartments</span> has
            been approved!
          </p>
          <div className="calendar">
            <FaCalendarWeek className="calend" />
            <h5>28 may 2020</h5>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardHome;
